import axios from 'axios'
import { Modal, Toast } from 'antd-mobile'
import { ExclamationTriangleOutline } from 'antd-mobile-icons'

//TODO
const baseUrl = 'https://dcep.kannh.com/kz/api/';

// const baseUrl = 'https://kzsv.cnnb.com.cn/jhsbapi/api/'

axios.defaults.baseURL = baseUrl
axios.defaults.headers.post['Authorization'] = 'THISISAAUTHHEADER'

const checkPhoneService = (data, callback) => {
    request('decp/send', data, callback)
}

const getUserInfo = (data, callback) => {
    request('getUserInfo', data, callback)
}

const pushInfo = (msg = "系统错误", title = '提示', callBack = null) => {
    Modal.alert({
        title: title,
        content: msg,
        closeOnMaskClick: true,
        onConfirm: callBack
    })
}

const request = (method, data, callback) => {
    loading()
    axios.post(method, data)
        .then(res => {
            Toast.clear()
            console.log("request OK", res)
            if (res.data.code === 0) {
                if (callback) {
                    callback(res.data)
                }
            } else {
                if(res.data.code === 203 || res.data.code === 204 ){
                    pushInfo(res.data.message, "恭喜")
                }else{
                    pushInfo(res.data.message, "抱歉")
                }
            }

        })
        .catch(err => {
            Toast.clear()
            Toast.show({
                icon: <ExclamationTriangleOutline />,
                content: '网络异常',
            })
            console.log(err)
        });
}

const loading = () => {
    Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false,
    })
}

const pushConfirm = (msg = "", title = '', callBack = null,onCancel=null) => {
    Modal.confirm({
        title: title,
        content: msg,
        closeOnMaskClick: true,
        onConfirm: callBack,
        onCancel:onCancel
    })
}
export { checkPhoneService, getUserInfo, pushInfo,pushConfirm }